export const COUNTRY_LIST_LOAD = "load_country_list_action"


export const LoadCountryList =  (page, itemsPerPage, query, cb) => {
  return {
    type: COUNTRY_LIST_LOAD,
    payload: { data: { page, itemsPerPage, query }, cb}
  }
}